import React from 'react'
import { Helmet } from "react-helmet";

import Block from '../components/block';
import Title from '../components/my-title';
import BlockCover from '../components/block-cover';

import PortfolioCover from '../assets/portfolio-cover.jpg';

import Img from "gatsby-image"

import { Modal, ModalBody } from 'reactstrap';

import data from '../data';

// console.log(props.pathContext.path);

class RealisationDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      img: null
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle(node = null) {
    this.setState({
      modal: !this.state.modal,
      img: node ? node.node.fullSizes : null
    })
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>{this.props.pathContext.node.meta.title}</title>
          <meta name="description" content={this.props.pathContext.node.meta.description} />
        </Helmet>
        <BlockCover
          backgroundUrl={PortfolioCover}
          title="Nos réalisations"
          repeatedTitle={true} />

        <Block hasDecoration>
          <Title small>{this.props.pathContext.node.title}</Title>
        </Block>

        <Block>
          <div className="row">
            {this.props.data.images ? this.props.data.images.edges.map((node, index) => (
              <div className="col-md-4 mb-4" onClick={() => this.toggle(node)} style={{
                cursor: 'pointer'
              }} key={index}>
                <div className="block-portfolio-item">
                  <div className="block-portfolio-item-background">
                    <Img
                      sizes={node.node.sizes}
                    />
                  </div>
                </div>
              </div>
            )) : null}
          </div>
        </Block>

        <Modal isOpen={this.state.modal} toggle={this.toggle} className="modal-lg">
          <ModalBody>
            <Img
              sizes={this.state.img}
            />
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

export const query = graphql`
  query FrontPageQuery($slug: String) {
    images: allImageSharp(filter: {
      id: {
        regex: $slug
      }
    }) {
      edges {
        node {
          sizes(maxWidth: 500, maxHeight: 500, cropFocus: CENTER) {
            ...GatsbyImageSharpSizes
          }
          fullSizes: sizes(maxWidth: 1000) {
            ...GatsbyImageSharpSizes
          }
        }
      }
    }
  }
`

export default RealisationDetail



// WEBPACK FOOTER //
// ./src/templates/realisation-detail.js